import {
  findMatchingVariant 
} from "@/util/findMatchingProductVariant"
import {
  isProductConfigurable 
} from "@/util/isProductConfigurable"
import {
  useMemo 
} from "react"

const getConfigPrice = (product, optionCodes, optionSelections) => {
  let value

  const {
    variants 
  } = product
  const isConfigurable = isProductConfigurable(product)

  const optionsSelected =
        Array.from(optionSelections.values()).filter((value) => !!value)
          .length > 0

  if (!isConfigurable || !optionsSelected) {
    value = product.price_range?.maximum_price
  } else {
    const item = findMatchingVariant({
      optionCodes,
      optionSelections,
      variants,
    })

    value = item
      ? item.product.price_range?.maximum_price
      : product.price_range?.maximum_price
  }

  return value
}

export const useGetProductPrice = ({
  product,
  optionCodes,
  optionSelections,
}: {
    product: any
    optionCodes: any
    optionSelections: any
}) => {
  const productPrice = useMemo(
    () => getConfigPrice(product, optionCodes, optionSelections),
    [product, optionCodes, optionSelections]
  )

  return {
    productPrice 
  }
}
